import { IBusStation } from "@/shared/types/busStaition";
import { IRoadmapWithPoints } from "../store/mapScreenSlce";
import { IVehicle } from "@/api/transport/types";
import { IFormStation } from "@/services/GET_FROM_OR_TO/types";

const calculateBounds = (coords: [number, number][]): [[number, number], [number, number]] => {
    let minLat = 90, maxLat = -90, minLng = 180, maxLng = -180;

    coords.forEach(([latitude, longitude]) => {
        if (latitude < minLat) minLat = latitude;
        if (latitude > maxLat) maxLat = latitude;
        if (longitude < minLng) minLng = longitude;
        if (longitude > maxLng) maxLng = longitude;
    });

    return [[minLat, minLng], [maxLat, maxLng]]; // Возвращаем массив крайних точек
};

function getMapBoundsForBusstaintions(busStations: IBusStation[]): {
    bounds: [[number, number], [number, number]]; options: IBoundsOptions
} {
    const allCoordinates: [number, number][] = busStations.map((point) => [
        parseFloat(point.stop_latitude),
        parseFloat(point.stop_longitude),
    ]);

    const bounds = calculateBounds(allCoordinates);

    const options: IBoundsOptions = {
        checkZoomRange: true,
        duration: 370,
    };

    if (busStations.length < 3) {
        options.zoomMargin = 420;
    }

    return { bounds, options };
}

const getMapBoundsForRoadmap = (roadmaps: IRoadmapWithPoints[]): {
    bounds: [[number, number], [number, number]];
    options: IBoundsOptions
} => {
    const allCoordinates: [number, number][] = roadmaps.flatMap((roadmap) =>
        roadmap.roadmapPoints?.map((point) => [point.latitude, point.longitude] as [number, number]) || []
    );
    if (allCoordinates.length === 0) {
        return {
            bounds: [[0, 0], [0, 0]],
            options: { checkZoomRange: true, duration: 370 }
        };
    }
    const bounds = calculateBounds(allCoordinates);

    const options: IBoundsOptions = {
        checkZoomRange: true,
        duration: 370,
    };

    if (allCoordinates.length < 3) {
        options.zoomMargin = 420;
    }

    return { bounds, options };
};

const getMapBoundsForVehicles = (vehicles: IVehicle[]): {
    bounds: [[number, number], [number, number]];
    options: IBoundsOptions
} => {
    const allCoordinates: [number, number][] = vehicles.map(({ lat, lon }) => [lat, lon]);
    if (allCoordinates.length === 0) {
        return {
            bounds: [[0, 0], [0, 0]],
            options: { checkZoomRange: true, duration: 370 }
        };
    }
    const bounds = calculateBounds(allCoordinates);

    const options: IBoundsOptions = {
        checkZoomRange: true,
        duration: 370,
    };

    if (allCoordinates.length < 3) {
        options.zoomMargin = 420;
    }

    return { bounds, options };
};

interface MapFormToBusOptions {
    cityId?: number | string;
    isRoadOverride?: boolean;
}

/**
 * Маппер из IFormStation[] (формат данных из формы)
 * в IBusStation[] (формат данных для карты).
 */
function mapFormStationsToBusStations(
    formStations: IFormStation[],
    options: MapFormToBusOptions = {}
): IBusStation[] {
    const { cityId, isRoadOverride } = options;

    return formStations.map<IBusStation>((s) => ({
        id: s.stop_id,
        //@ts-ignore
        name: s.stop_name,
        transport_type: s.transport_type,
        //@ts-ignore
        stoppoint_name: s.stop_name,
        stop_latitude: s.stop_latitude,
        stop_longitude: s.stop_longitude,
        city_id: cityId !== undefined ? Number(cityId) : undefined,
        area_id: s.area_id,
        area_name: s.area_name,
        isRoad: isRoadOverride ?? s.isRoad,
        // index оставляем undefined — это уже про маршрут, если нужно будет
    }));
}

export {
    calculateBounds,
    getMapBoundsForBusstaintions,
    getMapBoundsForRoadmap,
    getMapBoundsForVehicles,
    mapFormStationsToBusStations,
}



interface IBoundsOptions {
    checkZoomRange: boolean;
    duration: number;
    zoomMargin?: number;
}